const HOME_TV_DATA = {
    "id": "family_tv",
    "category":"family",
    "name": "family_tv",
    "levels": [
        {
            "tileSize": 256,
            "size": 256,
            "fallbackOnly": true
        },
        {
            "tileSize": 512,
            "size": 512
        },
        {
            "tileSize": 512,
            "size": 1024
        },
        {
            "tileSize": 512,
            "size": 2048
        }
    ],
    "faceSize": 2700,
    "initialViewParameters": {
        "pitch": 0,
        "yaw": 0,
        "fov": 1.2
    },
    "linkHotspots": [
        {
            "yaw": 3.0429370223396166,
            "pitch": 0.008281602961575985,
            "rotation": 0,
            "target": "family_fr",
            "category": "fridge",
            "pathname": "/family/fridge/side_by_sides/GSXV90MCDE",
            "targetCameraView": {
                "yaw": 0.2775142281923735,
                "pitch": 0.09072746761459882,
                "fov": 1.19
            },
            "targetCameraView2": {
                "yaw": -0.03908154865812463,
                "pitch": 0.23186754865708771,
                "fov": 1.19
            }
        },
        {
            "yaw": -0.0972898110656395,
            "pitch": -0.0730783582310206,
            "rotation": 0,
            "target": "family_tv",
            "category": "tvs",
            "pathname": "/family/tvs/tv/OLED65G29LA",
            "targetCameraView": {
                "yaw": 0.10170163433558876,
                "pitch": -0.012730057228903746,
                "fov": 1
            },
            "targetCameraView2": {
                "yaw": -0.06983403346835004,
                "pitch": 0.15003453702875873,
                "fov": 1
            }
        },
        {
            "yaw": -0.10113189977849046,
            "pitch": 0.09996591396404853,
            "rotation": 0,
            "target": "family_tv",
            "category": "av",
            "pathname": "/family/av/soundbar/DSP11RA",
            "targetCameraView": {
                "yaw": 0.10170163433558876,
                "pitch": -0.012730057228903746,
                "fov": 1
            },
            "targetCameraView2": {
                "yaw": -0.06983403346835004,
                "pitch": 0.15003453702875873,
                "fov": 1
            }
        },
        {
            "yaw": -0.44556180275365875,
            "pitch": 0.5500713212814361,
            "rotation": 0,
            "target": "family_tv",
            "category": "laptop",
            "pathname": "/family/laptop/laptop/17Z90Q-G.AD7CG",
            "targetCameraView": {
                "yaw": -0.06898087622193572,
                "pitch": 0.5375625648598241,
                "fov": 1
            },
            "targetCameraView2": {
                "yaw": -0.33753595976116735,
                "pitch": 0.5796172306151,
                "fov": 1
            }
        },
    ],
    "infoHotspots": [
        {
            "yaw": -0.3960511451342515,
            "pitch": 0.1081467759109167,
            "category": "tvs",
            "size": {w: 738, h: 441},
            "defaultModelName": "OLED65G29LA",
            "images": [
                {url: "products/update_20221115/home_product/TV/OLED/OLED65G29LA.png", modelName: "OLED65G29LA"},
            ],
            "radius": 1253,
            "extraTransforms": "rotateX(-6.0817622686164414deg) rotateY(-22.772273178834155deg)"
        },
        {
            "yaw": -0.3708609447432032,
            "pitch": 0.24148304738623594,
            "category": "av",
            "size": {w: 828, h: 238},
            "defaultModelName":"DSP11RA",
            "images": [
                {url: "products/update_20221115/home_product/SOUND_BAR/DSP11RA.png", modelName: "DSP11RA"},
            ],
            "radius": 1270,
            "radiusApple":1252,
            "extraTransforms": "rotateX(-13.835959439188985deg) rotateY(-21.24876692001998deg)"
        },
        {
            "yaw": -0.691726437442675,
            "pitch": 0.6660437099557204,
            "category": "laptop",
            "size": {w: 733, h: 464},
            "defaultModelName":"17Z90Q-G.AD7CG",
            "images": [
                {url: "products/update_20221115/home_product/LAPTOP/17Z90Q-G.AD7CG.png", modelName: "17Z90Q-G.AD7CG"},
            ],
            "radius": 1467,
            "extraTransforms": "rotateX(-4deg) rotateY(-34deg) rotateZ(21.3deg)"
        },
    ],
    "defaultTV":{
        "modelName": "none",
        "width": 560,
        "height": 316,
        "offsetX": 98,
        "offsetY": 64,
        "url":"videos/home_tv.mp4"
    }
};

export default HOME_TV_DATA;
